import React from 'react';
import { useAppSelector } from '../Store/store.ts';
import { CurrentStepSelector } from '../Selectors/FitAssistantSelectors.ts';
import FitAssistantStep from '../Enums/FitAssistantStep.ts';
import NoFit from '../Components/NoFit/NoFit.tsx';
import RooftopTentsRackSelector from '../Components/RackSelector/RoofTopTentsRackSelector.tsx';
import RooftopTentsVariationSelector from '../Components/VariationSelector/RooftopTentsVariationSelector.tsx';
import SelectList from '../Components/SelectList/SelectList.tsx';
import Confirmed from '../Components/Confirmed/Confirmed.tsx';

export const RooftopTents = () => {
  const currentStep = useAppSelector(CurrentStepSelector);

  const RenderStep = () => {
    switch (currentStep) {
      case FitAssistantStep.Make:
      case FitAssistantStep.Model:
      case FitAssistantStep.Year:
        return <SelectList />;
      case FitAssistantStep.Variation:
        return <RooftopTentsVariationSelector />;
      case FitAssistantStep.RoofRacks:
        return <RooftopTentsRackSelector />;
      case FitAssistantStep.NoFits:
        return <NoFit />;
      case FitAssistantStep.Confirmed:
      case FitAssistantStep.ConfirmedNoRacks:
        return <Confirmed />;
      default:
        return <></>;
    }
  };

  return <>{RenderStep()}</>;
};

export default RooftopTents;
